export const lowercaseFirstLetter = <T extends string>(value: T | undefined): Uncapitalize<T> | undefined => {
  if (typeof value !== 'string') {
    return value;
  }

  if (value?.[0]) {
    return (value[0].toLowerCase() + value.slice(1)) as Uncapitalize<T>;
  }

  return '' as Uncapitalize<T>;
};
